import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { Shared, UserService } from '@rubii/frontend-common';

@Component({
  selector: 'app-as',
  templateUrl: './adobe-search.component.html',
  styleUrls: ['./adobe-search.component.scss']
})
export class AdobeSearchComponent extends BaseDatasourceComponent implements OnInit {

  asEmail = '';

  constructor(private user: UserService) {
    super();
  }

  ngOnInit() {
    this.asEmail = 'report+as+' + this.user.user.tenant.token + '+' + this.user.user.id + '@rubii.io';
  }

}
